import { FormikErrors } from 'formik';
import { createContext, useContext } from 'react';
import { noop } from '@synergy/utils';

export interface FormikGroupItemContextData {
    validate: <T = unknown>() => Promise<FormikErrors<T>>;
    submit: <T = unknown>() => Promise<FormikErrors<T>>;
    reset: () => void;
}

export interface FormikGroupContextData {
    test: string;
    items: FormikGroupItemContextData[];
    register: (id: number, item: FormikGroupItemContextData) => void;
    /** Called when a step leaves the screen, so nothing submits a dead form. */
    unregister: (id: number) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: [stepperState: any, setStepperState: (state: any) => void];
}

export const FormikGroupContext = createContext<FormikGroupContextData>({
    test: 'test',
    items: [],
    register: noop,
    unregister: noop,
    state: [{}, noop],
});
export const useFormikGroupContext = () => useContext(FormikGroupContext);
